const carouselItems = [
  {
    title: '年度重磅：某顶流组合解散内幕全揭秘',
    desc: '从辉煌到分裂，深度复盘这支国民组合背后的利益纠葛与人性博弈',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20feature%20image%20representing%20celebrity%20group%20drama%20and%20entertainment%20industry%20conflict%20warm%20amber%20and%20deep%20coral%20toned%20geometric%20composition%20with%20dramatic%20lighting%20effects%20artistic%20magazine%20cover%20style%20with%20bold%20shapes%20and%20sophisticated%20gradients&width=600&height=340&seq=carousel-01&orientation=landscape',
  },
  {
    title: '独家复盘：某女星三年维权路与行业黑幕',
    desc: '从被雪藏到逆袭，一个关于勇气与坚持的真实故事引发全网共鸣',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20visual%20depicting%20entertainment%20industry%20justice%20and%20comeback%20story%20warm%20terracotta%20and%20rose%20tones%20with%20layered%20geometric%20patterns%20editorial%20design%20featuring%20dramatic%20contrast%20and%20bold%20composition%20sophisticated%20digital%20art&width=600&height=340&seq=carousel-02&orientation=landscape',
  },
  {
    title: '从素人到爆红：揭秘网红经济背后的操盘逻辑',
    desc: '深度解析流量密码与资本运作，还原网红产业链的真实生态',
    img: 'https://readdy.ai/api/search-image?query=Modern%20editorial%20abstract%20visual%20about%20digital%20influencer%20economy%20and%20social%20media%20trends%20warm%20coral%20gradient%20with%20dynamic%20data%20visualization%20elements%20and%20floating%20social%20icons%20artistic%20composition%20with%20sophisticated%20color%20palette&width=600&height=340&seq=carousel-03&orientation=landscape',
  },
  {
    title: '娱乐圈资源争夺战：谁在掌控话语权？',
    desc: '一线从业者亲述行业规则变化，资本入局后的权力重构',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20conceptual%20image%20about%20entertainment%20industry%20power%20dynamics%20and%20media%20influence%20warm%20copper%20and%20deep%20terracotta%20tones%20with%20bold%20geometric%20shapes%20intersecting%20in%20dynamic%20editorial%20layout%20high%20contrast%20artistic%20photography%20style&width=600&height=340&seq=carousel-04&orientation=landscape',
  },
  {
    title: '综艺节目"剧本"争议：真人秀到底有多真？',
    desc: '多位幕后工作人员爆料综艺制作流程，揭开真人秀的神秘面纱',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20behind%20the%20scenes%20entertainment%20industry%20abstract%20visual%20with%20warm%20amber%20lighting%20and%20dramatic%20shadow%20patterns%20revealing%20hidden%20truths%20modern%20editorial%20style%20with%20layered%20textures%20and%20bold%20coral%20accents%20sophisticated%20composition&width=600&height=340&seq=carousel-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            焦点速递
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            51吃瓜视频深度策划专题，聚焦近期最受关注的吃瓜大事件
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-4 md:gap-5">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="w-full sm:w-[calc(50%-10px)] lg:w-[calc(33.333%-14px)] xl:w-[calc(20%-16px)] min-w-[240px] flex-shrink-0 bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/60 transition-colors cursor-pointer group"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent" />
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}